import Axios from "axios"

/**
 * Fetches a URL with automatic retry on failure.
 *
 * @param {string} url
 * @param {object} options
 * @param {number} options.maxRetries - Maximum number of retries (default: 3)
 * @param {number} options.delay - Delay between retries in ms (default: 500)
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export default async function fetchWithRetry(
  url,
  { maxRetries = 2, delay = 300 } = {}
) {
  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    try {
      return await Axios.get(url)
    } catch (err) {
      if (attempt >= maxRetries) throw err

      await new Promise(resolve => setTimeout(resolve, delay))
    }
  }
}
